<div style="z-index: 10; position: absolute;">
    <div class="video-indicator" (click)="processNextVideo()" *ngIf="numOpenVideos>0">
        <i class="icon icon-video-filled icon-2x"></i>
        <span>{{numOpenVideos}}</span>
    </div>
</div>
